import React, { useEffect, useRef, useState } from "react";
import "./cok-header.m.css";
import PvLogoCok from "../../../atoms/other-icons/PvLogoCok";
import CokLogo from "../../../atoms/other-icons/CokLogo";
import { Link } from "@quintype/components";
import CokSignin from "./cok-signin";
import { useSelector } from "react-redux";
import { get, throttle } from "lodash";
import CokHamburgerMenu from "./cok-hamburger-menu";
import MyAccount from "../../../atoms/my-account";
import Modal from "../../../atoms/modal";
import CokMyAccountButton from "./cok-my-account-button";
import useDevice from "../../../helper/custom-hook/useDevice";
import User from "../../../atoms/other-icons/User";
import MyAccountButton from "../../../atoms/my-account-button";
import HamburgerMenu from "../../../atoms/hamburger-menu";

const CokHeader = ({
  getDropdownList,
  isMobileHamburger,
  toggleHandler,
  isHamburgerMenuOpen,
  closeModal,
  isOpen,
  onAccountHandler
}) => {
  const navRef = useRef();
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));

  const isMobile = useDevice();
  const [redirectURL, setRedirectUrl] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const secondaryMenus = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "cokMenus"], []));

  useEffect(() => {
    setRedirectUrl(window.location.href);

    window.addEventListener("scroll", throttle(getScroll, 250));
    return () => {
      window.removeEventListener("scroll", throttle(getScroll, 250));
    };
  }, []);

  const getScroll = () => {
    const valOfHeader = isMobile ? 99 : 116;
    if (typeof window !== "undefined") {
      if (window.scrollY > valOfHeader) {
        setIsSticky(true);
      }
      if (window.scrollY < valOfHeader) {
        setIsSticky(false);
      }
    }
  };

  const signinHandler = () => {
    if (window) {
      window.dataLayer.push({
        event: "SSO_Page_Open"
      });
    }

    window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectURL}`;
  };

  return (
    <>
      {isSticky ? (
        isMobile ? (
          <nav styleName="sticky-container">
            <div styleName="secondary-wrapper-sticky">
              {secondaryMenus.map((menu) => (
                <Link href={menu.url} id={menu.id}>
                  <span styleName="menu">{menu.title}</span>
                </Link>
              ))}
            </div>
            <div styleName="sticky-container-right">
              {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
                <button onClick={signinHandler} styleName="sign-in-only-icon">
                  <User width="16" height="16" />
                </button>
              ) : (
                <MyAccountButton onAccountHandler={onAccountHandler} />
              )}
              <Modal onClose={closeModal} isOpen={isOpen}>
                <MyAccount closeModal={closeModal} />
              </Modal>

              <CokHamburgerMenu
                isMobileHamburger={isMobileHamburger}
                onMenuToggle={() => toggleHandler()}
                isMegaMenuOpen={isHamburgerMenuOpen}
              />
              {getDropdownList()}
            </div>
          </nav>
        ) : (
          <nav styleName="sticky-container" ref={navRef}>
            <div styleName="sticky-container-left">
              <HamburgerMenu
                isMobileHamburger={false}
                onMenuToggle={() => toggleHandler()}
                isMegaMenuOpen={isHamburgerMenuOpen}
              />
              {getDropdownList()}
              <Link href="/">
                <img src="/icons/lstlogo.png" styleName="pv-logo" />
              </Link>

              <div styleName="secondary-wrapper-sticky">
                {secondaryMenus.map((menu) => (
                  <Link href={menu.url} id={menu.id}>
                    <span styleName="menu">{menu.title}</span>
                  </Link>
                ))}
              </div>
            </div>
            {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
              <button onClick={signinHandler} styleName="sign-in">
                <User color="black" width="16" height="16" />
                Sign in
              </button>
            ) : (
              <MyAccountButton onAccountHandler={onAccountHandler} />
            )}
            <Modal onClose={closeModal} isOpen={isOpen}>
              <MyAccount closeModal={closeModal} />
            </Modal>
          </nav>
        )
      ) : (
        <nav styleName="cok-header-container">
          <div styleName="cok-header-main-header">
            <div styleName="cok-header-main-header-container" className="container">
              <a href="/" styleName="cok-header-main-logo">
                <PvLogoCok />
              </a>
              <Link href="/food/cuisines-of-karnataka" styleName="cok-header-cok-logo">
                <img src="https://thumbor-stg.assettype.com/prajavani2/2025-08-04/5wvbptt4/coklogo" />
              </Link>
              <div styleName="cok-header-sign-hamburger">
                {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
                  <CokSignin signinHandler={signinHandler} />
                ) : (
                  <CokMyAccountButton onAccountHandler={onAccountHandler} />
                )}

                <Modal onClose={closeModal} isOpen={isOpen}>
                  <MyAccount closeModal={closeModal} />
                </Modal>
                <div styleName="cok-header-hamburger">
                  <CokHamburgerMenu
                    isMobileHamburger={isMobileHamburger}
                    onMenuToggle={() => toggleHandler()}
                    isMegaMenuOpen={isHamburgerMenuOpen}
                  />
                </div>
                {getDropdownList()}
              </div>
            </div>
          </div>
          <div styleName="cok-header-sub-header">
            <div className="container" styleName="cok-header-sub-header-container">
              <div styleName="secondary-wrapper">
                {secondaryMenus.map((menu) => (
                  <Link href={menu.url} id={menu.id}>
                    <span styleName="menu">{menu.title}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export default CokHeader;
